export class ClientError extends Error {
  constructor(...args) {
    let message = 'クライアントエラー'
    let data = null

    if (args.length === 1) {
      data = args[0]
    } else if (args.length === 2) {
      ;[message, data] = args
    } else if (args.length === 0) {
      // message and data stay as defaults
    } else {
      // fallback for unexpected arguments
      message = 'Invalid arguments'
    }

    super(message)
    this.name = 'ClientError'
    this.data = data

    // Capture stack trace (V8 environments only)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
  }
}
